import { render } from "./TopupLayout.vue?vue&type=template&id=13a066d0&ts=true"
import script from "./TopupLayout.vue?vue&type=script&lang=ts"
export * from "./TopupLayout.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__